module.exports = __webpack_public_path__ + "img/filter.388fe07b.svg";